import { Button } from "@chakra-ui/react";
import BasicTableTab from "features/commitments/tabs/BasicTableTab";
import { PortfolioTabProps } from "features/investments/PortfolioTabProps";
import { useInvestmentTableDataRetrieveSuspense } from "gen/endpoints/investment/investment";
import { PermissionTypeEnum } from "gen/model/permissionTypeEnum";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useOutletContext } from "react-router-dom";
import { Restricted } from "shared/components/access/Restricted";
import { GetLinkInfoForRowFn } from "shared/components/table/data/DataTableTypes";
import { rootRoute } from "shared/navigation/Routes";

export const PortfolioTabInvestments: React.FC = () => {
  const { t } = useTranslation(["investment", "common"]);
  const navigate = useNavigate();
  const { portfolioId, fundFamilyId } = useOutletContext<PortfolioTabProps>();

  const { data: tableData } = useInvestmentTableDataRetrieveSuspense(
    fundFamilyId,
    {
      portfolio_id: portfolioId,
    },
  );

  const getLinkInfoForRow = useCallback<GetLinkInfoForRowFn>(
    ({ row }) =>
      row.data?.metadata?.type === "id_row"
        ? {
            type: "generic",
            to: rootRoute({})
              .fundFamilies({})
              .fundFamily({ fundFamilyId })
              .investments({})
              .investment({ investmentId: row.data.metadata.id }).$,
          }
        : undefined,
    [fundFamilyId],
  );

  const addInvestmentButton = (
    <Restricted permission={PermissionTypeEnum.config}>
      <Button
        size="xs"
        onClick={() =>
          navigate(
            rootRoute({})
              .fundFamilies({})
              .fundFamily({ fundFamilyId })
              .investments({})
              .create({}).$,
          )
        }
      >
        {t("investment:add.button")}
      </Button>
    </Restricted>
  );

  return (
    <BasicTableTab
      tableTitle={t("investment:tabs.portfolioInvestments.title")}
      emptyStateProps={{
        title: t("investment:tabs.portfolioInvestments.table.empty.title"),
        description: t(
          "investment:tabs.portfolioInvestments.table.empty.description",
        ),
        children: addInvestmentButton,
      }}
      data={tableData}
      getLinkInfoForRow={getLinkInfoForRow}
    />
  );
};
